enum ThemeZIndices {
  ModalContent = 'modalContent',
  ModalOverlay = 'modalOverlay',
  Popover = 'popover',
}

export default ThemeZIndices;
